var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value.hide_edit === false)?_c('button',{staticClass:"alter-reservation-button",on:{"click":function($event){return _vm.alterReservation(_vm.value)}}},[_vm._v(" 予約変更する ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }